import type { WeaponDefinition, WeaponContext, WeaponResult } from './types';

const JETPACK_MAX_FUEL = 5.0;
const JETPACK_THRUST = 400;
const JETPACK_HORIZONTAL_SPEED = 150;

export const WeaponJetpack: WeaponDefinition = {
  id: 'jetpack',
  name: 'Jetpack [ALPHA]',
  icon: 'jetpack.png',
  category: 'utility',
  maxAmmo: 2,
  maxUsesPerTurn: 1,
  powerCharging: false,
  timerAdjustable: false,
  showAimGuide: false,
  allowRetreat: false,

  fire(ctx: WeaponContext): WeaponResult {
    const { worm } = ctx;

    if (worm.jetpackActive) {
      return {
        success: false,
        message: 'Jetpack already active',
      };
    }

    worm.jetpackActive = true;
    worm.jetpackFuel = JETPACK_MAX_FUEL;

    return {
      success: true,
      entities: [],
      message: 'Jetpack activated!',
    };
  },
};

export { JETPACK_MAX_FUEL, JETPACK_THRUST, JETPACK_HORIZONTAL_SPEED };
